import EcgEventsSelector from './EcgEventsSelector';

export default EcgEventsSelector;
